import React from 'react';

import { ITIN_LINK } from 'features/employeeProfile/PersonalInformationView/EmployeeInformationWidget/constants';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import { toI18n } from 'util/i18n';

export default function ITINError() {
  return (
    <Box>
      <Button inline theme="link" target="_blank" href={ITIN_LINK}>
        <Text fs12 red underline>
          ITINs
        </Text>
      </Button>
      &nbsp;
      {toI18n('team.employee_profile.employee_information.validations.itin')}
    </Box>
  );
}
